export const NewRegistrationBackground = 'rgba(6, 105, 191, 0.8)';
export const DeliveredBackground = 'rgba(242, 205, 94, 0.8)';
export const QueueBackground = 'rgba(34, 197, 94, 0.8)';

export const NewRegistrationBorder = 'rgba(6, 105, 191, 1)';
export const DeliveredBorder = 'rgba(242, 205, 94, 1)';
export const QueueBorder = 'rgba(34, 197, 94, 1)';

// Category colors for consistent styling
// export const categoryColors = {
//   allocated: 'rgba(54, 162, 235, 0.8)',
//   attempted: 'rgba(255, 99, 132, 0.8)',
//   connected: 'rgba(75, 192, 192, 0.8)',
//   unreached: 'rgba(255, 206, 86, 0.8)',
//   childAbove2Years: 'rgba(153, 102, 255, 0.8)',
//   notInPortal: 'rgba(255, 159, 64, 0.8)',
//   pending: 'rgba(199, 199, 199, 0.8)',
//   active: 'rgba(255, 165, 0, 0.8)',
//   unattempted: 'rgba(128, 0, 128, 0.8)'
// };

/**
 * Changing the colors based on the client requirements
 * They want the same colors used for the Case Analytics chart
 * to be used in the Category Analytics chart as well
 */
export const categoryColorsNewRegistration = {
  allocated: NewRegistrationBackground,
  attempted: NewRegistrationBackground,
  connected: NewRegistrationBackground,
  unreached: NewRegistrationBackground,
  childAbove2Years: NewRegistrationBackground,
  notInPortal: NewRegistrationBackground,
  pending: NewRegistrationBackground,
  active: NewRegistrationBackground,
  unattempted: NewRegistrationBackground
};

export const categoryColorsDelivered = {
  allocated: DeliveredBackground,
  attempted: DeliveredBackground,
  connected: DeliveredBackground,
  unreached: DeliveredBackground,
  childAbove2Years: DeliveredBackground,
  notInPortal: DeliveredBackground,
  pending: DeliveredBackground,
  active: DeliveredBackground,
  unattempted: DeliveredBackground
};

export const categoryBorderColors = {
  allocated: 'rgba(54, 162, 235, 1)',
  attempted: 'rgba(255, 99, 132, 1)',
  connected: 'rgba(75, 192, 192, 1)',
  unreached: 'rgba(255, 206, 86, 1)',
  childAbove2Years: 'rgba(153, 102, 255, 1)',
  notInPortal: 'rgba(255, 159, 64, 1)',
  pending: 'rgba(199, 199, 199, 1)',
  active: 'rgba(255, 165, 0, 1)',
  unattempted: 'rgba(128, 0, 128, 1)'
};

export const dataLabelsDefault = {
  color: "#ffffff",
  font: {
    weight: 'bold',
    size: 20
  }
}

export const dataLabelsCategoryDefault = {
  color: "#ffffff",
  font: {
    weight: 'bold',
    size: 14
  }
}